import { X, CheckCircle2 } from 'lucide-react';

const NotifyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 animate-in fade-in zoom-in duration-300">
      <div
        className="absolute inset-0 bg-teal-900/10 backdrop-blur-md"
        onClick={onClose}
      />
      <div className="relative bg-white p-8 sm:p-12 rounded-[3.5rem] shadow-[0_40px_120px_rgba(0,0,0,0.15)] border border-white w-full max-w-md text-center overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2.5 bg-gradient-to-r from-teal-500 to-emerald-500" />
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-2.5 hover:bg-gray-100 rounded-full transition-colors text-gray-400 cursor-pointer"
        >
          <X size={20} />
        </button>

        <div className="mb-6 inline-flex p-6 bg-teal-50 rounded-full text-teal-600">
          <CheckCircle2 size={56} strokeWidth={1.2} />
        </div>

        <h3 className="text-3xl font-black text-teal-900 mb-4 tracking-tight">
          Cinema Experience Awaits!
        </h3>
        <p className="text-gray-500 font-medium leading-relaxed mb-10 text-lg px-2">
          Get ready to be notified! You'll be among the first to experience the cinema of travel with cinematic video itineraries.
        </p>

        <button
          onClick={onClose}
          className="w-full py-5 bg-teal-600 hover:bg-teal-700 text-white rounded-[2rem] font-black transition-all shadow-xl shadow-teal-600/30 active:scale-95 text-lg cursor-pointer"
        >
          Awesome!
        </button>
      </div>
    </div>
  );
};

export default NotifyModal;
